export const API_GET_ALL_CENTER = "API_GET_ALL_CENTER";
export const API_GET_ALL_CENTER_SUCCESS = "API_GET_ALL_CENTER_SUCCESS";
export const API_GET_ALL_CENTER_FAIL = "API_GET_ALL_CENTER_FAIL";

export const API_GET_MY_CENTERS = "API_GET_MY_CENTERS";
export const API_GET_MY_CENTERS_SUCCESS = "API_GET_MY_CENTERS_SUCCESS";
export const API_GET_MY_CENTERS_FAIL = "API_GET_MY_CENTERS_FAIL";

export const API_ADMIN_GET_ALL_CENTER = "API_ADMIN_GET_ALL_CENTER";
export const API_ADMIN_GET_ALL_CENTER_SUCCESS = "API_ADMIN_GET_ALL_CENTER_SUCCESS";
export const API_ADMIN_GET_ALL_CENTER_FAIL = "API_ADMIN_GET_ALL_CENTER_FAIL";

export const API_ADMIN_GET_CENTER = "API_ADMIN_GET_CENTER";
export const API_ADMIN_GET_CENTER_SUCCESS = "API_ADMIN_GET_CENTER_SUCCESS";
export const API_ADMIN_GET_CENTER_FAIL = "API_ADMIN_GET_CENTER_FAIL";

export const API_ADMIN_PATCH_CENTER = "API_ADMIN_PATCH_CENTER";
export const API_ADMIN_PATCH_CENTER_SUCCESS = "API_ADMIN_PATCH_CENTER_SUCCESS";
export const API_ADMIN_PATCH_CENTER_FAIL = "API_ADMIN_PATCH_CENTER_FAIL";

export const API_ADMIN_POST_CENTER = "API_ADMIN_POST_CENTER";
export const API_ADMIN_POST_CENTER_SUCCESS = "API_ADMIN_POST_CENTER_SUCCESS";
export const API_ADMIN_POST_CENTER_FAIL = "API_ADMIN_POST_CENTER_FAIL";

export const API_ADMIN_DELETE_CENTER = "API_ADMIN_DELETE_CENTER";
export const API_ADMIN_DELETE_CENTER_SUCCESS = "API_ADMIN_DELETE_CENTER_SUCCESS";
export const API_ADMIN_DELETE_CENTER_FAIL = "API_ADMIN_DELETE_CENTER_FAIL";

export const API_ADMIN_IMPORT_CENTER = "API_ADMIN_IMPORT_CENTER";
export const API_ADMIN_IMPORT_CENTER_SUCCESS = "API_ADMIN_IMPORT_CENTER_SUCCESS";
export const API_ADMIN_IMPORT_CENTER_FAIL = "API_ADMIN_IMPORT_CENTER_FAIL";

export const RESET_CENTER = "RESET_CENTER";

export const SET_CENTER = "SET_CENTER";

export const ADMIN_INIT_NEW_CENTER = "ADMIN_INIT_NEW_CENTER";

export const ADMIN_RESET_FOCUS_CENTER = "ADMIN_RESET_FOCUS_CENTER";

export const API_GET_CENTER_TOUR_STATUS = "API_GET_CENTER_TOUR_STATUS";
export const API_GET_CENTER_TOUR_STATUS_SUCCESS = "API_GET_CENTER_TOUR_STATUS_SUCCESS";
export const API_GET_CENTER_TOUR_STATUS_FAIL = "API_GET_CENTER_TOUR_STATUS_FAIL";

export const API_GET_CENTERS_MY_RDV = "API_GET_CENTERS_MY_RDV";
export const API_GET_CENTERS_MY_RDV_SUCCESS = "API_GET_CENTERS_MY_RDV_SUCCESS";
export const API_GET_CENTERS_MY_RDV_FAIL = "API_GET_CENTERS_MY_RDV_FAIL";

export const API_GET_APPOINTMENTS_FOR_CENTER = "API_GET_APPOINTMENTS_FOR_CENTER";
export const API_GET_APPOINTMENTS_FOR_CENTER_SUCCESS = "API_GET_APPOINTMENTS_FOR_CENTER_SUCCESS";
export const API_GET_APPOINTMENTS_FOR_CENTER_FAIL = "API_GET_APPOINTMENTS_FOR_CENTER_FAIL";
